import { API_V2 } from "@/config/api";
import { RecurringPlan } from "@/types/models/RecurringPlan";
import apiRequest from "./api";

export const routes = {
  recurringPlansList: `${API_V2}/recurring`,
  stopRecurringPlan: (id: number) => `${API_V2}/recurring/${id}/stop`,
};

export interface RecurringPlansRequest {
  page: number;
  limit: number;
  sortBy: "createdAt" | "grossAmount";
  sortDirection: "ASC" | "DESC";
}

export interface ExtendedPlan extends RecurringPlan {
  donationCount: number;
}

export interface RecurringPlansResponse {
  result: ExtendedPlan[];
  total: number;
  page: number;
  pages: number;
}

export const stopRecurringPlanRequest = (id: number) =>
  apiRequest<RecurringPlan>(routes.stopRecurringPlan(id), {
    method: "DELETE",
  });
